/**
 * index.ts - FMwvTool Default Skin (Auto-switching)
 * 
 * Exports light, dark, and auto-switching variants.
 * The auto variant automatically switches based on system preferences.
 */

import { fmwvtoolDefaultLight } from './light.js';
import { fmwvtoolDefaultDark } from './dark.js';

/**
 * Auto-switching skin that respects system dark mode preference
 */
export const fmwvtoolDefault = {
  id: 'fmwvtool-default',
  name: 'FMwvTool Default (Auto)',
  description: 'Automatically switches between light and dark based on system preference',
  mode: 'auto' as const,
  
  variants: {
    light: fmwvtoolDefaultLight,
    dark: fmwvtoolDefaultDark,
  },
  
  // Use light mode variables as default
  variables: fmwvtoolDefaultLight.variables,
  plugins: fmwvtoolDefaultLight.plugins,
};

// Export individual variants
export { fmwvtoolDefaultLight } from './light.js';
export { fmwvtoolDefaultDark } from './dark.js';

// Export all skins as array for easy registration
/**
 * fmwvtoolSkins constant
 */
export const fmwvtoolSkins = [
  fmwvtoolDefault,
  fmwvtoolDefaultLight,
  fmwvtoolDefaultDark,
];

export default fmwvtoolDefault;
